import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  SwipeRowContainer,
  SwipeAction,
  SwipeMsgCard,
  MSG,
  MSGdetail,
  AvatarDot,
  DotIcon,
  IconView,
  MSGblock,
  Read,
  MSGtitle,
  MSGtext,
  DateSection,
  Desc,
  MSGtime,
  MSGsubtext,
  Bottom,
  ItemDiv,
  NotificationIcon,
  ResponsiveSnoozeButton,
  MainItemDiv
} from '../styles';
import Avatar from '../../../component/avatar';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import RenderInboxHtml from '../../../component/renderInbox';
import { Dropdown, DropdownDivider, DropdownItem } from '../../../component/dropdown';
import AssignBoxV2 from '../../../component/dropdowns/assignPopup';
import { useTaskAssignActions } from '../../../component/dropdowns/assignPopup/assignActions';
import CalendarDropdownMenuV2 from '../../../component/calendarPopUp/calendarDropdownMenuV2';
import dayjs from 'dayjs';
import { isEmpty, renderStatusIconName } from '../../../helpers/common';
import {
  AVATAR_BORDER,
  NOTIFICATION_TYPE,
  ASSIGN_REGEX,
  COMPLETE_REGEX,
  REOPEN_REGEX,
  REPLY_MESSAGE_REGEX,
  ICON_SIZE
} from '../../../global/constants';
import { NotificationItemProps } from '../../../interfaces/NotificationInterface';
import { NotificationModel } from '../../../mobx/models/notification';
import InboxActionButtons from '../inboxActionButtons';
import { rootStore } from '../../../mobx/rootStore';
import SnoozeCalendar from '../snoozeCalendar';

const renderProfileIcons = (type: number, title: string): React.ReactNode => {
  const assignIcon = ASSIGN_REGEX.test(title);
  const reopenIcon = REOPEN_REGEX.test(title);
  const completeIcon = COMPLETE_REGEX.test(title);
  const replyMessageIcon = REPLY_MESSAGE_REGEX.test(title);

  switch (type) {
    case NOTIFICATION_TYPE.TASK:
      if (assignIcon) {
        return (
          <NotificationIcon>
            <SVGIcon name='assign-task-icon' width='10' height='10' viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`} />
          </NotificationIcon>
        );
      } else if (reopenIcon) {
        return (
          <NotificationIcon>
            <SVGIcon name='reopen-task-icon' width='10' height='10' viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`} />
          </NotificationIcon>
        );
      } else if (completeIcon) {
        return (
          <NotificationIcon>
            <SVGIcon name='complate-task-icon' width='10' height='10' viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`} />
          </NotificationIcon>
        );
      }
      return <></>;
    case NOTIFICATION_TYPE.COMMENT:
      if (replyMessageIcon) {
        return (
          <NotificationIcon>
            <SVGIcon
              name='reply-icon'
              width='10'
              height='10'
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
          </NotificationIcon>
        );
      } else {
        return (
          <NotificationIcon>
            <SVGIcon name='mention-task-icon' width='10' height='10' viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`} />
          </NotificationIcon>
        );
      }
    case NOTIFICATION_TYPE.PROJECT_INVITE:
    case NOTIFICATION_TYPE.INVITE:
      return (
        <NotificationIcon>
          <SVGIcon name='project-invited-icon' width='10' height='10' viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`} />
        </NotificationIcon>
      );
    case NOTIFICATION_TYPE.VIEWS:
      return (
        <NotificationIcon>
          <SVGIcon
            name='navbar-views-icon'
            width='10'
            height='10'
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-primary)'
          />
        </NotificationIcon>
      );
    default:
      return <></>;
  }
};

const NotificationItem: React.FC<NotificationItemProps> = ({
  item,
  index,
  mobile,
  swipedItemId,
  touchStartX,
  touchEndX,
  isRearranging,
  deletingId,
  openDropdownId,
  subDropdownOpen,
  onClickInboxItem,
  onHoverChange,
  onClickReadIcon,
  onClickDeleteIcon,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  handleSubDropdownOpen,
  onClickUpdateStatus,
  onClickGroup,
  onClickUpdatePriority,
  isRecurringTask,
  isTemplateProject,
  calendarDate,
  setCalendarDate,
  currentProject,
  menuItems,
  isImageDescription,
  githubSvgIcon,
  setSubDropdownOpen,
  snoozeMenuItems,
  onClickSnoozeIcon,
  handleClick,
  handleTimeChange,
  onCancelSnooze,
  onClickSnooze,
  dropdownRefCalendar,
  onDateChange
}) => {
  const assignActions = useTaskAssignActions(item?.task, {
    isRecurring: isRecurringTask,
    isProjectTemplate: isTemplateProject
  });
  const renderSnoozeDropdown = (item: NotificationModel, isContextMenu: boolean) => {
    return (
      <Dropdown
        modalTitle='Snooze'
        content={
          isContextMenu ? (
            <DropdownItem
              label='Reschedule'
              iconName='snooze-icon'
              isActive={subDropdownOpen === 'Snooze'}
              iconViewBox='0 0 18 18'
            />
          ) : (
            <ResponsiveSnoozeButton>
              <SVGIcon
                name='snooze-icon'
                width={ICON_SIZE.MD}
                height={ICON_SIZE.MD}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                className='snooze-icon'
              />
              <div className='snooze-text'>Snooze</div>
            </ResponsiveSnoozeButton>
          )
        }
        updateDropdownOpen={(value) => {
          handleSubDropdownOpen(value, 'Snooze');
        }}
        trigger='click'
        onOutsideClick={() => {
          rootStore.snoozeStore.setIsCalendarOpen(false);
        }}
        isRemoveMaxHeight={true}
        isMinWidth={218}>
        {!rootStore.snoozeStore.isCalendarOpen &&
          snoozeMenuItems.map((dropdownItem) => (
            <DropdownItem
              key={dropdownItem.key}
              label={dropdownItem.label}
              iconName={dropdownItem.iconName}
              iconSize={16}
              iconViewBox='0 0 24 24'
              isSuffix={dropdownItem.RightSideLabel}
              isSnoozeDropdown={true}
              onClick={(e) => {
                e?.stopPropagation();
                handleClick(dropdownItem.key, item.id);
              }}
            />
          ))}
        {!rootStore.snoozeStore.isCalendarOpen && <DropdownDivider />}
        {!rootStore.snoozeStore.isCalendarOpen && (
          <MainItemDiv>
            <DropdownItem
              key='date-time'
              label='Date & Time'
              onClick={(e) => {
                e?.stopPropagation();
                rootStore.snoozeStore.setIsCalendarOpen(!rootStore.snoozeStore.isCalendarOpen);
                rootStore.snoozeStore.setOpenDropdownId(item.id);
              }}
              isSuffix={true}
            />
          </MainItemDiv>
        )}
        {rootStore.snoozeStore.isCalendarOpen && openDropdownId === item.id && (
          <SnoozeCalendar
            dropdownRef={dropdownRefCalendar}
            buttonHeight={rootStore.snoozeStore.buttonHeight}
            position={rootStore.snoozeStore.position}
            alignment={rootStore.snoozeStore.alignment}
            dropdownTopOffset={rootStore.snoozeStore.dropdownTopOffset}
            selectedDate={rootStore.snoozeStore.selectedDate}
            selectedTime={rootStore.snoozeStore.selectedTime}
            onBack={() => rootStore.snoozeStore.setIsCalendarOpen(false)}
            onCancel={onCancelSnooze}
            onSnooze={onClickSnooze}
            onDateChange={onDateChange}
            onTimeChange={handleTimeChange}
          />
        )}
      </Dropdown>
    );
  };
  return (
    <SwipeRowContainer key={item.id} className='swipe-row-no-animation' isActive={mobile && deletingId === item.id}>
      <SwipeAction>
        <div>
          <InboxActionButtons
            item={item}
            index={index}
            isTaskDetailPreview={false}
            mobile={mobile}
            snoozeMenuItems={snoozeMenuItems}
            onClickReadIcon={onClickReadIcon}
            onClickDeleteIcon={onClickDeleteIcon}
            onClickSnoozeIcon={onClickSnoozeIcon}
            handleClick={handleClick}
            handleTimeChange={handleTimeChange}
            onCancelSnooze={onCancelSnooze}
            onClickSnooze={onClickSnooze}
            dropdownRefCalendar={dropdownRefCalendar}
            onDateChange={onDateChange}
          />
        </div>
      </SwipeAction>
      <SwipeMsgCard
        isDeleting={deletingId === item.id}
        isSwiped={!!swipedItemId}
        touchStartX={touchStartX}
        touchEndX={touchEndX}
        isRearranging={isRearranging}
        swipedItemId={swipedItemId}
        itemId={item.id}
        mobile={mobile}>
        <Dropdown
          isRemoveMaxHeight={true}
          isMinWidth={148}
          content={
            <MSG
              role='button'
              key={item?.id}
              isRead={item?.isRead === true}
              onClick={(e) => {
                if (swipedItemId || !mobile) {
                  onClickInboxItem(e, item, index);
                }
              }}
              isIconActive={item?.id === openDropdownId}
              onMouseEnter={() => onHoverChange(item.id)}
              onMouseLeave={() => onHoverChange(null)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                }
              }}
              onTouchStart={(e) => {
                handleTouchStart(e, item.id);
              }}
              onTouchMove={(e) => {
                handleTouchMove(e);
              }}
              onTouchEnd={(e) => {
                handleTouchEnd(e);
              }}>
              <MSGdetail>
                <AvatarDot>
                  <DotIcon className='pointer'>
                    <SVGIcon
                      name='active-point-icon'
                      width='5'
                      height='5'
                      viewBox='0 0 5 6'
                      fill='none'
                      className='dot-icon'
                    />
                  </DotIcon>
                  {item?.senderId === 'github' ? (
                    <SVGIcon name={githubSvgIcon} width='28' height='28' viewBox='0 0 28 28' className='github-icon' />
                  ) : item?.senderId === 'sentry' ? (
                    <SVGIcon
                      name='sentry-icon'
                      width='28'
                      height='28'
                      viewBox={`0 0 ${ICON_SIZE.XXXXL} ${ICON_SIZE.XXXXL}`}
                      className='github-icon'
                    />
                  ) : (
                    <Avatar
                      imgSrc={item?.user?.profile_photo || ''}
                      name={item?.user?.name || ''}
                      size={28}
                      borderVariant={AVATAR_BORDER.NONE}
                      className='avatar'
                    />
                  )}
                  <IconView>{renderProfileIcons(item?.type, item?.title)}</IconView>
                </AvatarDot>
                <MSGblock>
                  <Read>
                    <MSGtitle>
                      {item?.title}
                      <span className='dot-icon'>・</span>
                      <DateSection>{dayjs(item?.date).fromNow()}</DateSection>
                    </MSGtitle>
                    {(item?.type === NOTIFICATION_TYPE.TASK || item?.type === NOTIFICATION_TYPE.VIEWS) && (
                      <MSGtext>{item?.description}</MSGtext>
                    )}
                  </Read>
                  {item?.type === NOTIFICATION_TYPE.COMMENT && item?.description && !isEmpty(item?.description) && (
                    <Desc isImage={isImageDescription(item?.description)}>
                      <RenderInboxHtml htmlString={item?.description} />
                    </Desc>
                  )}
                </MSGblock>
              </MSGdetail>
              <MSGtime>
                <MSGsubtext>{dayjs(item?.createdTime).fromNow()}</MSGsubtext>
                <Bottom>
                  <InboxActionButtons
                    item={item}
                    index={index}
                    isTaskDetailPreview={false}
                    mobile={mobile}
                    snoozeMenuItems={snoozeMenuItems}
                    onClickReadIcon={onClickReadIcon}
                    onClickDeleteIcon={onClickDeleteIcon}
                    onClickSnoozeIcon={onClickSnoozeIcon}
                    handleClick={handleClick}
                    handleTimeChange={handleTimeChange}
                    onCancelSnooze={onCancelSnooze}
                    onClickSnooze={onClickSnooze}
                    dropdownRefCalendar={dropdownRefCalendar}
                    onDateChange={onDateChange}
                  />
                </Bottom>
              </MSGtime>
            </MSG>
          }
          trigger='contextmenu'
          onOutsideClick={() => {
            rootStore.snoozeStore.setIsCalendarOpen(false);
            setSubDropdownOpen('');
          }}>
          <DropdownItem
            label='Mark as seen'
            iconName='true-icon'
            iconTone='fill'
            iconViewBox='0 0 18 18'
            onClick={() => onClickReadIcon(item)}
          />
          <DropdownItem
            label='Archive'
            iconName='bin-icon'
            iconTone='fill'
            iconViewBox='0 0 18 18'
            onClick={() => onClickDeleteIcon(item)}
          />

          {renderSnoozeDropdown(item, true)}

          {currentProject && item?.task && <DropdownDivider />}

          {currentProject && currentProject?.statusEnable && currentProject?.statusData?.length > 0 && item?.task && (
            <Dropdown
              isMinWidth={148}
              content={
                <ItemDiv>
                  <DropdownItem
                    label='Status'
                    iconName='task-todo-icon'
                    iconSize={16}
                    iconTone='fill'
                    isActive={subDropdownOpen === 'Status'}
                  />
                </ItemDiv>
              }
              trigger='hover'
              updateDropdownOpen={(value) => {
                handleSubDropdownOpen(value, 'Status');
              }}>
              {currentProject?.statusData.map((status) => {
                const currentStatus =
                  currentProject?.statusData.find((s) => s?.['_id'] === item?.task?.statusId) ||
                  currentProject?.statusData?.find((s) => s?.Default);
                return (
                  <DropdownItem
                    key={status?.['_id']}
                    label={status.Name}
                    onClick={() => onClickUpdateStatus(item?.task!, status, currentStatus!)}
                    iconName={renderStatusIconName(status.Type)}
                  />
                );
              })}
            </Dropdown>
          )}

          {currentProject && currentProject?.isGroupEnabled && currentProject?.taskGroups?.length > 0 && item?.task && (
            <Dropdown
              isMinWidth={148}
              content={
                <ItemDiv>
                  <DropdownItem
                    label='Group'
                    iconName='updated-group-icon'
                    iconSize={16}
                    iconViewBox='0 0 18 18'
                    iconTone='fill'
                    isActive={subDropdownOpen === 'Group'}
                  />
                </ItemDiv>
              }
              trigger='hover'
              updateDropdownOpen={(value) => {
                handleSubDropdownOpen(value, 'Group');
              }}>
              {currentProject?.taskGroups?.map((group) => (
                <DropdownItem key={group.id} label={group.name} onClick={() => onClickGroup(item?.task!, group)} />
              ))}
            </Dropdown>
          )}

          {currentProject && currentProject?.priority?.enabled && (
            <Dropdown
              isMinWidth={148}
              content={
                <ItemDiv>
                  <DropdownItem
                    label='Priority'
                    iconName='Priority-High-icon'
                    iconSize={16}
                    iconTone='fill'
                    isActive={subDropdownOpen === 'Priority'}
                  />
                </ItemDiv>
              }
              trigger='hover'
              updateDropdownOpen={(value) => {
                handleSubDropdownOpen(value, 'Priority');
              }}>
              {menuItems.map((priority) => (
                <DropdownItem
                  key={priority.key}
                  label={priority.label}
                  onClick={() => onClickUpdatePriority(item?.task!, priority.key)}
                  iconName={priority.icon}
                />
              ))}
            </Dropdown>
          )}

          {currentProject && currentProject?.users && item?.task && (
            <AssignBoxV2
              projectUsers={currentProject?.users}
              context={{ mode: 'task', currentTask: item.task }}
              onAssign={assignActions.onAssign}
              onUnassign={assignActions.onUnassign}
              isContextMenu={true}
              isMultiAssignee={currentProject?.multiAssignee}
              isActive={subDropdownOpen === 'Assignee'}
              updateDropdownOpen={(value) => {
                handleSubDropdownOpen(value, 'Assignee');
              }}
            />
          )}

          {currentProject && item?.task && (
            <Dropdown
              isMinWidth={148}
              trigger='hover'
              isRemoveMaxHeight={true}
              content={
                <ItemDiv>
                  <DropdownItem
                    label='Due date'
                    iconName='calendar-icon'
                    iconSize={16}
                    iconViewBox='0 0 18 18'
                    isActive={subDropdownOpen === 'Due date'}
                  />
                </ItemDiv>
              }
              updateDropdownOpen={(value) => {
                handleSubDropdownOpen(value, 'Due date');
              }}>
              <CalendarDropdownMenuV2
                isRecurringTask={isRecurringTask}
                taskData={item?.task}
                calendarDate={calendarDate}
                setCalendarDate={setCalendarDate}
              />
            </Dropdown>
          )}
        </Dropdown>
      </SwipeMsgCard>
    </SwipeRowContainer>
  );
};

export default observer(NotificationItem);
